export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
